import { _defineProperty } from "@slyte/core/src/lyte-utils";
import { Route } from "../../../node_modules/@slyte/router/index.js";
let StepperComp;

class Stepper extends Route {
  render() {
    return { outlet: '#zcatcomponent', component: StepperComp };
  }

  static actions(arg1) {
    return Object.assign(super.actions({}), arg1);
  }

  _() {
    _;
  }

  getRequirements() {
    arguments[1].push(import(
      /* webpackChunkName: "components/javascript/lyte-components/stepper-comp" */
      "../../../components/javascript/lyte-components/stepper-comp"
    ).then(function(res) {
      StepperComp = res.StepperComp;
    }));

    
;
  }
}

export { Stepper };
